export default class TexnitesDetails{
    constructor(obj) {
        this.Texnitis_ID = obj.Texnitis_ID;
        this.TexnitisName = obj.TexnitisName;
        this.HasMobileApp = obj.HasMobileApp;
    }
}
